import React, { useState } from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import { Box } from '@mui/system';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

export default function DialogUpdateVersionContext({ open, onClose, updateVersion }) {
  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog
      open={open}
      // onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        <Box sx={{ padding: '15px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
          <Typography variant="h3">Nueva actualización!!!</Typography>
          <img width="80%" src="/static/illustrations/reload.svg" alt="" />
          <Typography variant="subtitle1">Dagpacket se ha actualizado con mejoras para ti.</Typography>
          <Typography variant="subtitle2">Dale click al botón actualizar para traer los nuevos cambios.</Typography>
          <Button fullWidth variant="contained" onClick={updateVersion}>
            Actualizar version
          </Button>
        </Box>
      </DialogContent>
      {/* <DialogActions>
        <Button onClick={handleClose} color="inherit" startIcon={<KeyboardBackspaceIcon />}>
          Atras
        </Button>
      </DialogActions> */}
    </Dialog>
  );
}
